import React from 'react';

import { useStyledTheme } from 'hooks/useStyledTheme';

import SvgIcon from '../SvgIcon';

const IconPost = (props: React.SVGAttributes<SVGSVGElement>) => {
  const theme = useStyledTheme();

  return (
    <SvgIcon viewBox="0 0 594 516" {...props}>
      <path fill="#e5ebed" d="M507.9 45.4h-54.8V6.6h54.8l-16 19.4z" />
      <path fill="#c2d2da" d="M451.6 6.6h3v164.2h-3z" />
      <path
        fill="#c2d2da"
        d="M511.1 46.9h-59.5V5.1h59.5L493.9 26l17.2 20.9zm-56.5-3h50.1L490 26l14.7-17.9h-50.1v35.8z"
      />
      <path fill="#fff" d="M584.4 125.1H145.8V88.7h403.3a35.2 35.2 0 0 1 35.2 35.2v1.2z" />
      <path
        fill="#c2d2da"
        d="M585.9 126.6H144.3V87.2h404.8a36.7 36.7 0 0 1 36.7 36.7v2.7zm-438.6-3h435.5a33.7 33.7 0 0 0-33.7-33.4H147.3v33.4z"
      />
      <path fill="#e5ebed" d="M145.8 117.4h438.6v274.7H145.8z" />
      <path
        fill="#c2d2da"
        d="M585.9 393.5H144.3V115.9h441.6v277.6zm-438.6-3h435.6V118.9H147.3v271.6z"
      />
      <ellipse fill="#e5ebed" cx="60.9" cy="479.7" rx="48.8" ry="6" />
      <path
        fill="#e5ebed"
        d="M60.9 392h169.9V170.8a82.2 82.2 0 0 0-82.1-82.1H143a82.2 82.2 0 0 0-82.1 82.1V392z"
      />
      <path
        fill="#c2d2da"
        d="M232.2 393.5H59.4V170.8A83.7 83.7 0 0 1 143 87.2h5.7a83.7 83.7 0 0 1 83.6 83.6v222.7zm-169.8-3h166.9V170.8a80.7 80.7 0 0 0-80.6-80.6H143a80.7 80.7 0 0 0-80.6 80.6v219.7z"
      />
      <ellipse fill="#e5ebed" cx="430.7" cy="503.6" rx="131.5" ry="6" />
      <path
        fill={theme.colors.fountainBlue}
        d="M543.3 359.9H370.8V176.2h172.5v183.7zm-169.5-3h166.5V179.2H373.8v177.7z"
      />
      <path fill="#fff" d="M344.2 287.3l-43.6 25.2v149.2h261.6V312.5l-43.6-25.2" />
      <path
        fill="#fff"
        d="M344.2 337V200.1h174.4v136m-411.9 97.5a5 5 0 0 1 5-5v-9.3c-2.8 0-5-2.2-5-5s2.2-5 5-5V400c-2.8 0-5-2.2-5-5s2.2-5 5-5v-9.3c-2.8 0-5-2.2-5-5s2.2-5 5-5v-9.3c-2.8 0-5-2.2-5-5s2.2-5 5-5v-7.3h-7.3c0 2.8-2.2 5-5 5s-5-2.2-5-5h-9.3c0 2.8-2.2 5-5 5s-5-2.2-5-5h-9.3c0 2.8-2.2 5-5 5s-5-2.2-5-5h-9.3c0 2.8-2.2 5-5 5s-5-2.2-5-5h-9.3c0 2.8-2.2 5-5 5s-5-2.2-5-5H9.9v7.3c2.8 0 5 2.2 5 5s-2.2 5-5 5v9.3c2.8 0 5 2.2 5 5s-2.2 5-5 5v9.3c2.8 0 5 2.2 5 5s-2.2 5-5 5v9.3c2.8 0 5 2.2 5 5s-2.2 5-5 5v9.3c2.8 0 5 2.2 5 5s-2.2 5-5 5v7.3h7.3c0-2.8 2.2-5 5-5s5 2.2 5 5h9.3c0-2.8 2.2-5 5-5s5 2.2 5 5h9.3c0-2.8 2.2-5 5-5s5 2.2 5 5h9.3c0-2.8 2.2-5 5-5s5 2.2 5 5h9.3c0-2.8 2.2-5 5-5s5 2.2 5 5h7.3v-7.3a5 5 0 0 1-5-5z"
      />
      <ellipse fill="#fff" cx="313.8" cy="91.5" rx="47.8" ry="47.8" />
      <path
        fill={theme.colors.fountainBlue}
        d="M113.2 447.3h-10.3v-1.5c0-1.9-1.6-3.5-3.5-3.5s-3.5 1.6-3.5 3.5v1.5H83.6v-1.5c0-1.9-1.6-3.5-3.5-3.5s-3.5 1.6-3.5 3.5v1.5H64.4v-1.5c0-1.9-1.6-3.5-3.5-3.5s-3.5 1.6-3.5 3.5v1.5H45.1v-1.5c0-1.9-1.6-3.5-3.5-3.5s-3.5 1.6-3.5 3.5v1.5H25.9v-1.5c0-1.9-1.6-3.5-3.5-3.5s-3.5 1.6-3.5 3.5v1.5H8.6V437h1.5c1.9 0 3.5-1.6 3.5-3.5S12 430 10.1 430H8.6v-12.3h1.5c1.9 0 3.5-1.6 3.5-3.5s-1.6-3.5-3.5-3.5H8.6v-12.3h1.5c1.9 0 3.5-1.6 3.5-3.5s-1.6-3.5-3.5-3.5H8.6v-12.3h1.5c1.9 0 3.5-1.6 3.5-3.5s-1.6-3.5-3.5-3.5H8.6V360h1.5c1.9 0 3.5-1.6 3.5-3.5S12 353 10.1 353H8.6v-10.3h10.3v1.5c0 1.9 1.6 3.5 3.5 3.5s3.5-1.6 3.5-3.5v-1.5h12.3v1.5c0 1.9 1.6 3.5 3.5 3.5s3.5-1.6 3.5-3.5v-1.5h12.3v1.5c0 1.9 1.6 3.5 3.5 3.5s3.5-1.6 3.5-3.5v-1.5h12.3v1.5c0 1.9 1.6 3.5 3.5 3.5s3.5-1.6 3.5-3.5v-1.5h12.3v1.5c0 1.9 1.6 3.5 3.5 3.5s3.5-1.6 3.5-3.5v-1.5h10.3V353h-1.5c-1.9 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5h1.5v12.3h-1.5c-1.9 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5h1.5v12.3h-1.5c-1.9 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5h1.5v12.3h-1.5c-1.9 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5h1.5v12.3h-1.5c-1.9 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5h1.5v10.1zm-7.5-3h4.4v-4.4c-2.9-.7-5-3.3-5-6.3s2.1-5.6 5-6.3v-6.6c-2.9-.7-5-3.3-5-6.3s2.1-5.6 5-6.3v-6.6c-2.9-.7-5-3.3-5-6.3s2.1-5.6 5-6.3v-6.6c-2.9-.7-5-3.3-5-6.3s2.1-5.6 5-6.3v-6.6c-2.9-.7-5-3.3-5-6.3s2.1-5.6 5-6.3v-4.4h-4.4c-.7 2.9-3.3 5-6.3 5s-5.6-2.1-6.3-5h-6.6c-.7 2.9-3.3 5-6.3 5s-5.6-2.1-6.3-5h-6.6c-.7 2.9-3.3 5-6.3 5s-5.6-2.1-6.3-5h-6.6c-.7 2.9-3.3 5-6.3 5a6.4 6.4 0 0 1-6.3-5h-6.6c-.7 2.9-3.3 5-6.3 5s-5.6-2.1-6.3-5h-4.4v4.4c2.9.7 5 3.3 5 6.3s-2.1 5.6-5 6.3v6.6c2.9.7 5 3.3 5 6.3s-2.1 5.6-5 6.3v6.6c2.9.7 5 3.3 5 6.3s-2.1 5.6-5 6.3v6.6c2.9.7 5 3.3 5 6.3s-2.1 5.6-5 6.3v6.6c2.9.7 5 3.3 5 6.3s-2.1 5.6-5 6.3v4.4H16c.7-2.9 3.3-5 6.3-5s5.6 2.1 6.3 5h6.6c.7-2.9 3.3-5 6.3-5 3.1 0 5.6 2.1 6.3 5h6.6c.7-2.9 3.3-5 6.3-5s5.6 2.1 6.3 5h6.6c.7-2.9 3.3-5 6.3-5s5.6 2.1 6.3 5h6.6c.7-2.9 3.3-5 6.3-5s6 2.2 6.6 5z"
      />
      <path
        fill={theme.colors.fountainBlue}
        d="M103.2 437.4H18.6v-84.7h84.6v84.7zm-81.6-3h78.6v-78.7H21.6v78.7z"
      />
      <path
        fill={theme.colors.fountainBlue}
        d="M87.3 437.4H17.2l35-50.6 35.1 50.6zm-64.4-3h58.6L52.2 392l-29.3 42.4z"
      />
      <path fill="#fff" d="M81.3 406.4l20.4 29.5H60.9z" />
      <path
        fill={theme.colors.fountainBlue}
        d="M104.6 437.4H58l23.3-33.6 23.3 33.6zm-40.9-3h35.1L81.3 409l-17.6 25.4zm13.2-48.9c-5 0-9-4-9-9s4-9 9-9 9 4 9 9-4 9-9 9zm0-15c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm236.9-229.7a49.4 49.4 0 1 1 34.8-14.4 48.7 48.7 0 0 1-34.8 14.4zm0-95.6a46 46 0 0 0-46.3 46.2 46.3 46.3 0 1 0 46.3-46.2z"
      />
      <path
        fill={theme.colors.fountainBlue}
        d="M346.2 108l-2.7-1.4a33.3 33.3 0 0 0-6.1-38.7 33.3 33.3 0 0 0-38.7-6.1l-1.4-2.7c14.1-7.2 31-4.5 42.2 6.7a36.2 36.2 0 0 1 6.7 42.2zm-32.4 19.8c-9.4 0-18.7-3.7-25.7-10.7a36.1 36.1 0 0 1-6.6-42.1l2.7 1.4a33.3 33.3 0 0 0 6.1 38.7 33.3 33.3 0 0 0 38.7 6.1l1.4 2.7c-5.3 2.6-11 3.9-16.6 3.9zm-17.4-51.5l2.1-2.2 32.7 32.7-2.1 2.1z"
      />
      <g fill={theme.colors.accent}>
        <path d="M563.7 463.2H299.1V311.7l44.3-25.7 1.5 2.6-42.8 24.8v146.8h258.6V313.4l-42.9-24.8 1.5-2.6 44.4 25.7z" />
        <path d="M345.7 337h-3V198.6h177.4v137.5h-3V201.6H345.7z" />
        <path d="M299.8 313.8l1.5-2.6 261.6 149.1-1.5 2.6z" />
        <path d="M427.2 383.6l134.3-72.4 1.4 2.6-134.3 72.4zm-39.4-132.7H475v3h-87.2zm0 43.6H475v3h-87.2z" />
      </g>
    </SvgIcon>
  );
};

export default IconPost;
